import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">Ending Your "This Color, That Color" dilemmas</div>
  );
};

export default Footer;
